import { Alerts } from '@/feature/alerts/components/AlertsProvider';
import { logger } from '@/utils/logging';
import i18n from 'i18next';

import { PicksValidationProcessor, ValidateResponse } from '.';
import { useBetslipStore } from '../hooks/use-betslip-store';
import { BetslipPick, PlayerWithTeam } from '../types';
import { getExceedsMaxEdgeCombosErrorMsg } from '../utils/betslip-utils';

type Context = {
    latestPick: BetslipPick | undefined;
    removeFunction: (picks: { eventId: string; player: PlayerWithTeam }[]) => void;
    alertsContext: Alerts;
    openBetslip: () => void;
};

const LOG_TAG = '[Betslip-Exceeds-Edge-Combos]';
export class PicksExceedsEdgeComboProcessor extends PicksValidationProcessor<Context> {
    process(data: ValidateResponse): void {
        const activeGameMode = useBetslipStore.getState().activeGameMode;
        const result = data.validateEntryOnEntryRules.find(it => it.gameMode === activeGameMode);

        if (!result) {
            logger.warn(LOG_TAG, `No validation result for active ${activeGameMode} game mode found.`);
            return;
        }

        const exceedsMaxEdgeCombosErrorMsg = getExceedsMaxEdgeCombosErrorMsg(result);

        const { latestPick, removeFunction } = this.context;
        const { showInfoSheet } = this.context.alertsContext;

        if (exceedsMaxEdgeCombosErrorMsg) {
            if (latestPick) {
                removeFunction([latestPick]);
                showInfoSheet({
                    title: i18n.t('error:betslip_pickem.edge_combos_maxed_out_title'),
                    description: exceedsMaxEdgeCombosErrorMsg,
                    buttonLabel: i18n.t('betslip_pickem:edit_lineup'),
                    handlePress: () => {
                        this.context.openBetslip();
                    },
                    secondaryLabel: i18n.t('common:dismiss'),
                });
            }
        } else {
            this.nextProcessor?.process(data);
        }
    }
}
